import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import EventCard from "@/components/feature/EventCard";
import { events } from "@/mocks/events";

export default function TopicGrid() {
  return (
    <section className="py-14 md:py-20 bg-background-100 border-y border-background-200">
      <div className="max-w-shell mx-auto px-4 md:px-6">
        <SectionHeading
          eyebrow="Hot Topics"
          title="热点专题"
          desc="每一条专题都保留完整的时间线，从首发到反转再到后续，不用来回翻找旧消息。"
          action={
            <Link
              to="/events"
              className="inline-flex items-center gap-1.5 px-4 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              全部分类
              <i className="ri-arrow-right-line" />
            </Link>
          }
        />
        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {events.slice(0, 6).map((event) => (
            <EventCard key={event.id} event={event} />
          ))}
        </div>
      </div>
    </section>
  );
}